module.exports = __webpack_public_path__ + "img/gameicon.2ad47f25.png";